module.exports = __webpack_public_path__ + "static/media/6_6.b2631409.jpg";